
// src/web/components/group-selection-dialog.jsx

import React from 'react'
import { translate } from 'react-i18next'
import { PropTypes } from 'prop-types'
import connect from '../../connects/group-selection-dialog'
import classnames from 'classnames'
import _ from 'lodash'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  List,
  ListItem,
  ListItemContent,
} from 'react-toolbox/lib/list'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import Checkbox from 'react-toolbox/lib/checkbox'
import Input from './compact-input.jsx'
import Avatar from 'react-toolbox/lib/avatar'
import Chip from 'react-toolbox/lib/chip'
import ScrollableDialogPanel from './scrollable-dialog-panel.jsx'
import { InfiniteScroll } from './infinite-scroller'
import { deleteArray } from '../../helpers/store'
import NotificationBadge, { Effect } from 'react-notification-badge'
import { linkUI, resetUI } from '../../helpers/form-validator'
import theme from './themes/action-dialog.css'
import noPaddingListTheme from './themes/no-padding-list.css'
import noScrollBarTheme from './themes/no-scrollbar.css'

class GroupSelectionDialogProvider extends React.Component {
  state = {}

  fetchGroups = () => !this.props.isFetching && this.props.fetchGroups(this.props)

  render() {
    const {
      t,
      ui,
      groups,
      hasMore,
      isFetching,
      updateUI,
      fetchGroups,
      onSelect,
      onFinish,
      children,
    } = this.props
    if (!groups)
      return null
    const visibleGroups = ui.query ? groups.filter(group => group.name.includes(ui.query)) : groups

    return (
      <div>
        <Dialog active={ui.active} theme={theme}
          title={
            !ui.search &&
            <div style={{ display: 'flex' }}>
              <div>
                {ui.title}
                {ui.selected && ui.selected.length > 0 &&
                  <NotificationBadge count={ui.selected.length}
                    containerStyle={{ display: 'inline' }}
                    style={{ top: 'auto', right: 'auto' }} />}
              </div>
              <div style={{ marginLeft: 'auto', marginRight: 0 }}>
                <IconButton icon="search" onClick={() => updateUI({ search: true })} />
              </div>
            </div> ||
            <div style={{ display: 'flex' }}>
              <Input type='text' className="fluid"
                hint={t('label:名前で検索')}
                value={ui.query}
                hasFocus
                onChange={linkUI(this, 'query', (value) => !value && updateUI({ search: false }))} />
              <div style={{ marginLeft: 'auto', marginRight: 0 }}>
                <IconButton icon="close" onClick={() => updateUI({ search: false, query: undefined })} />
              </div>
            </div>}
          actions={_.filter([
            { raised: true, label: t('label:取り消し'), onClick: () => updateUI({ active: false }) },
            ui.multiple && { primary: true, raised: true, icon: 'check', label: t('label:OK'), onClick: () => {onFinish(this.props)} },
          ], (item) => item)}
          onOverlayClick={() => updateUI({ active: false })}
          onEscKeyDown={() => updateUI({ active: false })} >

          {ui.multiple && (!ui.selected || ui.selected == '') && <Button label={t('label:すべて選択')} raised style={{ marginTop: 4 }} onClick={() => this.props.selectAll(this.props, visibleGroups)}/>}
          {ui.multiple && ui.selected && ui.selected != '' && <Button label={t('label:すべて解除')} raised style={{ marginTop: 4 }} onClick={() => this.props.unselectAll(this.props)}/>}
          <ScrollableDialogPanel extraHeight={ui.multiple ? 71 : 0}>
            {ui.active &&
            <InfiniteScroll pageStart={0}
                element="ul"
                className={classnames(noPaddingListTheme.list)}
                loadMore={this.fetchGroups}
                hasMore={hasMore}
                initialLoad={false}
                loader={isFetching && <ListItem caption={t('label:読み込み中')} />}
                useWindow={false} >
              {visibleGroups && visibleGroups.map((group)=>
                <ListItem key={group.group_id} selectable
                    onClick={()=> ui.selected && ui.selected.find((v) => v.group_id == group.group_id ) ? updateUI({ selected: deleteArray('group_id', ui.selected, group.group_id) }) : onSelect(this.props, group)}
                    avatar={!(ui.selected && ui.selected.find((v) => v.group_id == group.group_id )) && <Avatar image={group.icon_image.thumb_url} /> || <Avatar style={{ backgroundColor: '#5067FF' }} icon={<FontIcon value='check' style={{ width: 'inherit', marginTop: 8 }} />}/>}
                    caption={group.name} >
                  <ListItemContent>
                  <div>
                    <p style={{ color: 'rgb(33, 33, 33)', fontSize: 16 }}>{group.name}</p>
                    <p style={{ color: 'rgb(117, 117, 117)' }}>{ t('label:persons_count', { value: group.members_count }) }</p>
                  </div>
                  </ListItemContent>
                </ListItem>
              )}
            </InfiniteScroll>}
          </ScrollableDialogPanel>
        </Dialog>
        {children}
      </div>
    )
  }
}

export const RawGroupSelectionDialogProvider = GroupSelectionDialogProvider
export default connect(GroupSelectionDialogProvider)



// WEBPACK FOOTER //
// ./src/web/components/group-selection-dialog.jsx